import { render, staticRenderFns } from "./CpdVisitations.vue?vue&type=template&id=235a5707"
import script from "./CpdVisitations.vue?vue&type=script&lang=js"
export * from "./CpdVisitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports